import { createSelector } from 'reselect';

const selectPickupPoints = (state: any) => state.pickupPoints;


export const selectPickupPointsCurrentItem = createSelector([selectPickupPoints], (pickupPoints) => pickupPoints.current);

export const selectPickupPointsListItems = createSelector([selectPickupPoints], (pickupPoints) => pickupPoints.list);

export const selectPickupPointsItemById = (itemId: any) =>
    createSelector(selectPickupPointsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectPickupPointsQueryItems = createSelector([selectPickupPoints], (pickupPoints) => pickupPoints.query);

export const selectPickupPointsCreatedItem = createSelector([selectPickupPoints], (pickupPoints) => pickupPoints.create);

export const selectPickupPointsUpdatedItem = createSelector([selectPickupPoints], (pickupPoints) => pickupPoints.update);

export const selectPickupPointsReadItem = createSelector([selectPickupPoints], (pickupPoints) => pickupPoints.read);

export const selectPickupPointsDeletedItem = createSelector([selectPickupPoints], (pickupPoints) => pickupPoints.delete);

export const selectPickupPointsSearchedItems = createSelector([selectPickupPoints], (pickupPoints) => pickupPoints.search);

export const selectPickupPointsItemsCount = createSelector([selectPickupPoints], (pickupPoints) => pickupPoints.count);

export const selectPickupPointsItemsFilter = createSelector([selectPickupPoints], (pickupPoints) => pickupPoints.filter);